module.exports = __webpack_public_path__ + "static/media/logo.0084acb9.png";